<template>
    <div>
        <b-button
            id="report-accuracy-info-popover"
            variant="link"
            size="sm"
            class="p-0 ml-1 text-secondary"
            style="font-size: 0.875rem;margin-top: -2px"
        >
            <fa icon="question-circle"></fa>
        </b-button>
        <b-popover
            target="report-accuracy-info-popover"
            :show.sync="showPopover"
            triggers="click"
            placement="right"
            custom-class="report-examples-popover"
            @shown="onPopoverShown"
            @hidden="onPopoverHidden"
        >
            <template #title>
                <div class="d-flex justify-content-between align-items-center">
                    <span>{{ $t('옵션 셜명') }}</span>
                    <b-button
                        variant="link"
                        size="sm"
                        class="p-0 text-secondary"
                        @click="closePopover"
                    >                        <fa icon="times"></fa>

                    </b-button>
                </div>
            </template>
            <section>
                <div>
                    {{ $t('결과보고서 파일명 자동생성을 해제하면 우측 결과보고서 이름 입력란이 활성화 되고, 해당 입력란에 의해서 결과보고서 이름이 변경됩니다. ')}}
                </div>
                <div>
                    {{ $t('입력 변수로 다음을 활용할 수 있으며 중괄호로 감싸서 변수를 입력할 수 있습니다.')}}
                </div>
                <ul>
                    <li>{{ $t('프로젝트코드: {프로젝트코드}') }}</li>
                    <li>{{ $t('업체코드: {업체코드}') }}</li>
                    <li>{{ $t('기업명: {기업명}') }}</li>
                    <li>{{ $t('모드 - DOC, OSIS 생성 보고서 선택에서 선택된 모드가 사용됩니다: {모드}') }}</li>
                    <li>{{ $t('날짜 - 생성기를 실행한 날짜가 표기됩니다. ex) 20251110-1124: {날짜}') }}</li>
                    <li>{{ $t('언어 - 결과보고서 생성 언어가 표기됩니다. ex) ENG / KOR / CHI: {언어}') }}</li>
                </ul>
            </section>
        </b-popover>
    </div>
</template>

<script>
export default {
    name: 'ReportFileNameHelp',
    data() {
        return {
            showPopover: false,
        };
    },
    methods: {
        closePopover() {
            this.showPopover = false;
        },
        onPopoverShown() {
            // 외부 클릭 시 popover 닫기
            document.addEventListener('click', this.handleOutsideClick);
            // 스크롤 시 popover 닫기
            window.addEventListener('scroll', this.handleScroll, true);
        },
        onPopoverHidden() {
            // 이벤트 리스너 제거
            document.removeEventListener('click', this.handleOutsideClick);
            window.removeEventListener('scroll', this.handleScroll, true);
        },
        handleOutsideClick(event) {
            // popover 요소와 트리거 버튼 확인
            const popoverElement = document.querySelector('.report-examples-popover');
            const triggerElement = document.getElementById('report-accuracy-info-popover');
            
            if (popoverElement && triggerElement) {
                // 클릭된 요소가 popover 내부나 트리거 버튼이 아닌 경우
                if (!popoverElement.contains(event.target) && !triggerElement.contains(event.target)) {
                    this.closePopover();
                }
            }
        },
        handleScroll() {
            this.closePopover();
        }
    }
};
</script>

<style lang="scss">
.report-examples-popover {
    max-width: 480px !important;
    .report-examples {
        .example-case {
            
            padding: 12px;
            border-radius: 6px;

            &:last-child {
                margin-bottom: 4px;
            }
            .title-wrapper {
                display: flex;
                align-items: center;
                gap: 8px;
                h6 {
                    font-weight: 600;
                    font-size: 0.9rem;
                    margin-bottom: 0;
                }
            }

            

            .example-text {
                border: 1px solid #dee2e6;
                border-radius: 8px;
                padding: 8px 12px;
                line-height: 1.5;
                margin-bottom: 0;
                font-size: 0.95rem;
            }
        }
    }

}
</style>
